import React, { useState } from "react";
import { 
  Container, 
  Form, 
  Button, 
  Card, 
  Alert,
  Row,
  Col
} from "react-bootstrap";
import { FaSignInAlt, FaUserShield } from "react-icons/fa";
import { theme } from "../styles/theme";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { BASE_URL } from "../constants";

export default function Login({ setIsAuth }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await axios.post(`${BASE_URL}/login`, {
        email,
        password,
      });

      const { token, user } = response.data;
      localStorage.setItem("auth_token", token);
      localStorage.setItem("user", JSON.stringify(user));
      
      setIsAuth(token);
      navigate("/dashboard/stats");
      
      Swal.fire({
        icon: "success",
        title: "Connexion réussie",
        text: `Bienvenue, ${user.name || 'utilisateur'} !`,
        showConfirmButton: false,
        timer: 1500,
        background: theme.colors.white,
      });
    } catch (err) {
      console.error("Login error:", err);
      setError(
        err.response?.data?.message || "Une erreur est survenue lors de la connexion"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div 
      className="d-flex align-items-center justify-content-center" 
      style={{ 
        minHeight: "100vh", 
        background: `linear-gradient(135deg, ${theme.colors.primary} 0%, ${theme.colors.secondary} 100%)`,
        padding: "2rem 1rem"
      }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} md={8} lg={6} xl={5}>
            <Card className="shadow-lg border-0 rounded-lg overflow-hidden">
              <Card.Header 
                className="text-center py-4" 
                style={{ 
                  backgroundColor: theme.colors.primary,
                  color: theme.colors.white
                }}
              >
                <div className="d-flex align-items-center justify-content-center mb-3">
                  <FaUserShield size={32} className="me-2" />
                  <h2 className="mb-0">Connexion</h2>
                </div>
                <p className="mb-0">Accédez à votre espace d'administration</p>
              </Card.Header>
              
              <Card.Body className="p-4 p-md-5">
                {error && <Alert variant="danger" className="text-center">{error}</Alert>}
                
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-4">
                    <Form.Label>Adresse email</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Entrez votre email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      className="py-3"
                    />
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <div className="d-flex justify-content-between align-items-center">
                      <Form.Label>Mot de passe</Form.Label>
                    </div>
                    <Form.Control
                      type="password"
                      placeholder="Entrez votre mot de passe"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      className="py-3"
                    />
                  </Form.Group>

                  <Button 
                    variant="primary" 
                    type="submit" 
                    className="w-100 py-3 mt-4"
                    disabled={loading}
                    style={{
                      backgroundColor: theme.colors.primary,
                      border: 'none',
                      fontWeight: 600,
                      letterSpacing: '0.5px'
                    }}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Connexion en cours...
                      </>
                    ) : (
                      <>
                        <FaSignInAlt className="me-2" />
                        Se connecter
                      </>
                    )}
                  </Button>
                </Form>
              </Card.Body>
            
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}